/** Static platform icon / label hints for earned-media cards (UI only). */
const PLATFORM_MATCHERS = [
	{ pattern: /clutch/i, label: "CL", className: "monitoring__earned-icon--clutch" },
	{ pattern: /reddit/i, label: "RD", className: "monitoring__earned-icon--reddit" },
	{ pattern: /linkedin/i, label: "IN", className: "monitoring__earned-icon--linkedin" },
	{ pattern: /shopify/i, label: "SP", className: "monitoring__earned-icon--shopify" },
	{ pattern: /g2/i, label: "G2", className: "monitoring__earned-icon--g2" },
	{ pattern: /twitter|x\.com/i, label: "X", className: "monitoring__earned-icon--twitter" },
	{ pattern: /youtube/i, label: "YT", className: "monitoring__earned-icon--youtube" },
	{ pattern: /facebook|meta/i, label: "FB", className: "monitoring__earned-icon--facebook" },
];

export function getEarnedMediaIcon(platform = "", channelType = "") {
	const haystack = `${platform} ${channelType}`.trim();
	for (const entry of PLATFORM_MATCHERS) {
		if (entry.pattern.test(haystack)) {
			return entry;
		}
	}
	const initial = (platform || channelType || "?").trim().charAt(0).toUpperCase() || "?";
	return {
		label: initial,
		className: "monitoring__earned-icon--fallback",
	};
}
